import React from 'react';
import { Dialog, DialogContent, IconButton, useTheme, alpha } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type ImageZoomModalProps = {
  open: boolean;
  onClose: () => void;
  imageSrc: string;
  alt: string;
};

const ImageZoomModal = ({ open, onClose, imageSrc, alt }: ImageZoomModalProps) => {
  const theme = useTheme();
  const zoomDialogPaperSx = {
    backgroundColor: alpha(theme.palette.common.black, 0.9),
    boxShadow: 'none',
    maxWidth: '90vw',
    maxHeight: '90vh',
    margin: '5vh auto',
    width: 'fit-content',
    height: 'fit-content',
  } as const;
  const zoomCloseButtonSx = {
    position: 'absolute',
    top: 8,
    right: 8,
    color: theme.palette.common.white,
    backgroundColor: alpha(theme.palette.common.black, 0.5),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.black, 0.7),
    },
    zIndex: 1,
  } as const;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: zoomDialogPaperSx,
      }}
    >
      <DialogContent
        sx={{
          padding: 0,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          position: 'relative',
          overflow: 'auto',
          maxWidth: '90vw',
          maxHeight: '90vh',
        }}
      >
        <IconButton onClick={onClose} sx={zoomCloseButtonSx}>
          <CloseIcon />
        </IconButton>
        <img
          src={imageSrc}
          alt={alt}
          style={{
            display: 'block',
            width: 'auto',
            height: 'auto',
            objectFit: 'none',
            minWidth: 'auto',
            minHeight: 'auto',
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImageZoomModal;
